import { Button, Card, Grid, Icon, Pagination, Stack, TextField } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import * as modalActions from "./modalActionTypes";
import React, { useEffect, useState } from "react";
// Data
import companiesTableData from "./data/CompaniesTable";
import DataTable from "examples/Tables/DataTable";
import { Box } from "@mui/system";
import MDButton from "components/MDButton";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "./redux/state/CompaniesAction";
import CompanyModal from "./components/CompanyModal";
import FormUpdateCompany from "./components/FormUpdateCompany";
import FormAddCompany from "./components/FormAddCompany";
import ComfirmeDeleteCompany from "./components/ComfirmeDeleteCompany";
import FormUploadCompany from "./components/FormUploadCompany";

function Countries() {
  const [open, setOpen] = useState(false);
  const [companyId, setCompanyId] = useState("");
  const [action, setAction] = useState(modalActions.ADD);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState();
  const [text, setText] = useState();
  const handleOpen = () => {
    setAction(modalActions.ADD);
    setCompanyId("");
    setOpen(true);
  };
  const handleUpload = () => {
    setAction(modalActions.UPLOAD);
    setCompanyId("");
    setOpen(true);
  };
  
  const changePage=(event, value)=>{
    console.log(value);
    setPage(old=>value)
  }

  // const dispatch = useDispatch();
  // useEffect(() => {
  //   dispatch(actions.getCompanies());
  // }, []);
  // const data = useSelector((state) => state?.companies?.companies);

  const { columns, rows, data } = companiesTableData(setOpen, setCompanyId, setAction,page, search);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Box mr={1}>
          <MDButton onClick={handleOpen} to="#" variant="contained" size="small" color="info">
            <Icon>add</Icon> entreprise
          </MDButton>
        </Box>
        <Box mr={1}>
          <MDButton to="#" variant="contained" size="small" color="success" onClick={handleUpload}>
            Importer <Icon>uploadfile</Icon>
          </MDButton>
        </Box>
      </Box>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                    <MDTypography variant="h6" color="white" style={{ display:"flex",alignItems:"center",justifyContent:"space-between" }}>
                      Entreprises
                    <div style={{ backgroundColor:"white", borderRadius:"10px" }}>
                      <TextField onChange={(event)=>setText(event.target.value)}  label="search" id="search" />
                      <Button onClick={()=>setSearch(text)}>Rechercher</Button></div>
                    </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                {rows && 
                <>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  showTotalEntries={false}
                  noEndBorder
                  pagination={false}
                  entriesPerPage={search ? 100 : false}
                />
                <Box sx={{ mt: 2}} style={{ paddingBottom:"20px", paddingLeft:"20px" }}>
                    <Stack spacing={2}>
                        <Pagination
                        count={data.last_page} 
                        variant="outlined" 
                        shape="rounded"
                        page={page} 
                        onChange={changePage}
                        />
                    </Stack>
                </Box>
                </>}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <CompanyModal
        open={open}
        setOpen={setOpen}
        title={
          action == modalActions.UPDATE
            ? "Modifier entreprise"
            : action == modalActions.DELETE
            ? "Supprimer entreprise"
            : "Ajouter entreprise"
        }
      >
        {/* ADD MODAL */}
        {action == modalActions.ADD && (
          <FormAddCompany setOpen={setOpen} setAction={setAction} setCompanyId={setCompanyId} />
        )}

        {/* UPDATE MODAL */}
        {action == modalActions.UPDATE && (
          <FormUpdateCompany
            setOpen={setOpen}
            setAction={setAction}
            setCompanyId={setCompanyId}
            companyId={companyId}
          />
        )}

        {/* DELETE MODAL */}
        {action == modalActions.DELETE && (
          <ComfirmeDeleteCompany
            setOpen={setOpen}
            setAction={setAction}
            setCompanyId={setCompanyId}
            companyId={companyId}
          />
        )}

        {action == modalActions.UPLOAD && (
          <FormUploadCompany
            setOpen={setOpen}
            setAction={setAction}
            setCompanyId={setCompanyId}
            companyId={companyId}
          />
        )}
      </CompanyModal>
      ;
    </DashboardLayout>
  );
}
export default Countries;
